var _style, _polygon, _polygon2, _path, _path2, _rect, _polygon3, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSblabsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 281.5 65.1",
    style: {
      enableBackground: "new 0 0 281.5 65.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#504F4C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#9076AC;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,2 0,10.1 8.5,13.5 8.5,10.5 54.6,10.5 54.6,17 35.9,24.5 46.7,28.8 63.1,22.3 63.1,2 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,22.3 54.6,44.1 54.6,56.6 8.5,56.6 8.5,35.4 0,38.8 0,65.1 63.1,65.1 63.1,38.8 0,13.6 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.7,45.7l2.8-4.8c3.6,2.4,7.4,3.9,11.6,3.9c4.2,0,6.4-1.7,6.4-3.9c0-2.9-2.3-3.7-7.5-4.9 c-7.7-1.6-12.4-4.5-12.4-10.5c0-6.3,5.7-9.7,13-9.7c4.8,0,8.6,1.3,12.2,4l-3.3,4.5c-2.4-1.7-5.7-2.9-9.3-2.9c-3.9,0-6.1,1.3-6.1,4.2 c0,2.4,2.1,3.7,7.5,4.9c8.2,1.8,12.4,4,12.4,9.9c0,6.2-5.6,10-13.4,10C90.3,50.5,85.3,48.6,81.7,45.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.1,41c0,5.6-4.7,9-12.4,9h-17.2V16.4h16.8c7.1,0,11.5,3.2,11.5,8.5c0,3.6-2.1,6.6-5.2,7.8 C142.5,33.7,145.1,37,145.1,41 M121.6,21.9v8.4h9.3c4.7,0,6.6-1.4,6.6-4.2c0-3-2.1-4.2-6.6-4.2H121.6z M131.8,44.5 c5,0,7.1-1.4,7.1-4.3c0-3.2-2.4-4.4-7.3-4.4h-9.9v8.7H131.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 43.9,
    className: "st2",
    width: 6.9,
    height: 6.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "170.3,50 170.3,16.4 174,16.4 174,46.7 193.7,46.7 193.7,50 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.2,33.8V50h-3.6v-4.9c-1.4,2.4-4.9,5.4-10,5.4c-5.6,0-9-3.3-9-8c0-4.7,3.1-8.3,10.2-8.3 c3.1,0,6.1,0.2,8.8,0.5v-0.9c0-4.6-2.7-7.1-7.8-7.1c-2.7,0-5.7,1-8,2.9l-1.8-2.6c2.9-2.5,6.6-3.5,10.1-3.5 C215.5,23.6,219.2,27.3,219.2,33.8 M215.6,38.6v-0.8c-2.4-0.4-4.9-0.6-8-0.6c-5.3,0-7.5,1.9-7.5,5c0,3.1,2.4,4.9,6.6,4.9 C211.9,47.2,215.6,42.7,215.6,38.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.8,37c0,7.8-5.5,13.5-12.6,13.5c-4.4,0-8.3-1.9-10.5-5.3V50h-3.6V14.5h3.6v14.4c2.2-3.4,6.1-5.3,10.5-5.3 C248.3,23.6,253.8,29,253.8,37 M250.2,37c0-5.9-4-10.1-9.6-10.1c-5.8,0-10,4-10,10.1c0,6.1,4.2,10.2,10,10.2 C246.2,47.2,250.2,43,250.2,37z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.1,47l1.5-3c2.9,2,6.3,3.1,9.5,3.1c4.2,0,6.8-1.4,6.8-4.2c0-2.4-1.9-3.5-7.3-4.5c-7.4-1.4-9.7-3.6-9.7-7.4 c0-4.6,3.6-7.3,9.6-7.3c3.4,0,7.6,1,10,2.7l-1.5,3c-2.3-1.6-5.6-2.5-8.8-2.5c-3.6,0-5.7,1.3-5.7,3.7c0,2.2,1.6,3.3,7,4.3 c7.6,1.6,9.9,3.8,9.9,7.8c0,4.8-4.1,7.6-10.6,7.6C264.8,50.4,260.7,48.9,258.1,47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.5,45.7H44.2V21.4h24.3V45.7z M74.5,15.4H38.1v36.4h36.4V15.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSblabsLogo);
export default __webpack_public_path__ + "static/media/sblabs_logo.0647fb681b7d8d6bf86125bd6c9253ab.svg";
export { ForwardRef as ReactComponent };